// OperationDashboardScreen.js (Updated)
import React, { useState } from "react";
import {
  Box,
  Typography,
  Stack,
  IconButton,
  alpha,
  useTheme,
  Paper,
  Divider,
} from "@mui/material";
import {
  Refresh as RefreshIcon,
  ViewModule as ViewModuleIcon,
  ViewList as ViewListIcon,
} from "@mui/icons-material";
import LatestAlerts from "../../components/OperationDashboard/LatestAlerts";
import Birthdays from "../../components/OperationDashboard/Birthdays";
import TodaysTeam from "../../components/OperationDashboard/TodaysTeam";
import ActionProgress from "../../components/OperationDashboard/ActionProgresses";
import OperationTabs from "../../components/OperationDashboard/OperationTabs";
import ViewToggleButton from "./ViewToggleButton";
import QuickStatsGrid from "./QuickStatsGrid";
import SectionWrapper from "./SectionWrapper";

const OperationDashboardScreen = () => {
  const theme = useTheme();
  const [viewMode, setViewMode] = useState("overview");

  return (
    <Box sx={{ px: 1, bgcolor: "#f5f7fa", minHeight: "100vh" }}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 3,
          flexWrap: "wrap",
          gap: 2,
        }}
      >
        <Box>
          <Typography variant="h5" fontWeight={700} color="#1A1A2E" sx={{ fontSize: "1.5rem" }}>
            Operations Dashboard
          </Typography>
          <Typography variant="caption" color="text.secondary" sx={{ fontSize: "0.75rem" }}>
            {viewMode === "overview"
              ? "Real-time overview of operations performance"
              : "Detailed operations management"}
          </Typography>
        </Box>
        <Stack direction="row" spacing={1} alignItems="center">
          <ViewToggleButton
            mode="overview"
            label="Overview"
            icon={<ViewModuleIcon />}
            viewMode={viewMode}
            setViewMode={setViewMode}
          />
          <ViewToggleButton
            mode="operations"
            label="Operations"
            icon={<ViewListIcon />}
            viewMode={viewMode}
            setViewMode={setViewMode}
          />
          <IconButton
            size="small"
            sx={{
              bgcolor: "white",
              "&:hover": { bgcolor: alpha(theme.palette.primary.main, 0.04) },
            }}
          >
            <RefreshIcon fontSize="small" />
          </IconButton>
        </Stack>
      </Box>

      {viewMode === "overview" ? (
        <>
          <QuickStatsGrid />

          <Box sx={{ display: "grid", gridTemplateColumns: "1fr", gap: 3.5 }}>
            <SectionWrapper
              title="Action Progress & Alerts"
              subtitle="Track ongoing operations and active alerts"
              actionLabel="View All"
              onAction={() => {}}
            >
              <Box
                sx={{
                  display: "grid",
                  gridTemplateColumns: { xs: "1fr", lg: "1fr 1fr" },
                  gap: 2.5,
                }}
              >
                <ActionProgress />
                <LatestAlerts />
              </Box>
            </SectionWrapper>

            <SectionWrapper
              title="Team & Celebrations"
              subtitle="Today's team members and upcoming birthdays"
              actionLabel="View All"
              onAction={() => {}}
            >
              <Box
                sx={{
                  display: "grid",
                  gridTemplateColumns: { xs: "1fr", lg: "1fr 1fr" },
                  gap: 2.5,
                }}
              >
                <TodaysTeam />
                <Birthdays />
              </Box>
            </SectionWrapper>
          </Box>
        </>
      ) : (
        <Paper
          sx={{
            p: 2.5,
            borderRadius: 2,
            bgcolor: "white",
            border: `1px solid ${alpha(theme.palette.divider, 0.3)}`,
          }}
        >
          <Divider sx={{ mb: 2.5, opacity: 0.4 }} />
          <OperationTabs />
        </Paper>
      )}
    </Box>
  );
};

export default OperationDashboardScreen;